module.exports = __webpack_public_path__ + "img/logo1 (25).8f1c4bce.jpg";